import { useCallback } from 'react';
import { useInterval } from 'usehooks-ts';
import { makeVar, useReactiveVar } from '@apollo/client';
import { getServerVersion } from './settings.service';

export const serverVersionVar = makeVar<string | null>(null);

// If a major or minor version update is detected during current client session then force refresh the client to get supporting updates to client build
export const useServerVersionRegulator = () => {
  const cachedVersion = useReactiveVar(serverVersionVar);

  const findVersionDifference = useCallback(
    (newVersion: string) => {
      if (cachedVersion !== newVersion) {
        serverVersionVar(newVersion);

        if (cachedVersion) {
          console.log('Evaluating server version update', { newVersion, cachedVersion });
          const splitNew = newVersion.split('.');
          const splitCached = cachedVersion.split('.');

          if (splitNew.length < 2 || splitCached.length < 2) return 'unknown';
          if (parseInt(splitNew[0]) > parseInt(splitCached[0])) return 'major';
          if (parseInt(splitNew[1]) > parseInt(splitCached[1])) return 'minor';
          return 'incremental';
        }
      }

      return 'no-change';
    },
    [cachedVersion]
  );

  const refreshCacheAndReload = () => {
    console.log('Clearing cache and hard reloading...');

    if (caches)
      caches.keys().then((names) => {
        for (const name of names) caches.delete(name);
      });

    // @ts-expect-error Ignore skip cache param type error
    window.location.reload(true);
  };

  useInterval(async () => {
    const {
      data: { version: newVersion }
    } = await getServerVersion();

    const diff = findVersionDifference(newVersion);
    if (['major', 'minor'].includes(diff)) {
      console.log('Handling significant server version update by refreshing client');
      refreshCacheAndReload();
    }
  }, 60000);
};
